<template>
  <router-link class="legal-card" :to="{ name: RouteNames.LegalDetail, params: { id: props.legal.cid } }">
    <status-string
      class="ml-auto"
      :text="LEGAL_APPROVE_STATUS_MAP[props.legal.approveStatus].name"
      :variant="LEGAL_APPROVE_STATUS_MAP[props.legal.approveStatus].color"
    />
    <div class="paragraph-s text-secondary mt-3">
      <span>ИНН:</span><span class="font-600 ml-2">{{ props.legal.legalDetails.tin }}</span>
      <template v-if="props.legal.legalDetails.kpp">
        <span class="text-grey-lighten-2 mx-2">|</span>
        <span>КПП::</span><span class="font-600 ml-2">{{ props.legal.legalDetails.kpp }}</span>
      </template>
    </div>
    <div class="paragraph-m font-600 mt-3">{{ props.legal.name[0].value }}</div>
  </router-link>
</template>

<script setup lang="ts">
import type { LegalsListItemType } from '@/parts/legals/store/legals';
import StatusString from '@/core/components/common/StatusString.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { LEGAL_APPROVE_STATUS_MAP } from '@/parts/legals/utils/consts';

const props = defineProps<{
  legal: LegalsListItemType;
}>();
</script>

<style scoped lang="scss">
.legal-card {
  display: flex;
  flex-direction: column;

  min-height: 200px;
  padding: 16px;

  background-color: $main-bg-color;
  border-radius: $border-radius-l;

  cursor: pointer;

  @include hover {
    box-shadow: $border-box-shadow;
  }
}
</style>
